$hyoo_js_eval $mol_book2
	Placeholder null
	plugins /
		<= Theme $mol_theme_auto
		<= Submit $mol_hotkey
			key * enter? <=> submit? null
			mod_ctrl true
	bookmark_list? /string
		\
			\// Example Notebook
			\
			\// load external script
			\const {
			\	$mol_compare_deep: compare
			\} = $mol_import.module(
			\	'https://esm.sh/mol_compare_deep'
			\).default
			\
			\// local vars
			\const one = [1]
			\one.push( one )
			\const left =  { a: [1,one], b:    one  }
			\const right = { a:    one,  b: [1,one] }
			\
			\// result
			\compare( left, right )
	pages /
		<= Menu_page $mol_page
			title @ \Bookmarks
			tools /
				<= Clear $mol_link
					arg * code null
					sub /
						<= Clear_icon $mol_icon_plus
				<= Source $mol_link_source
					uri \https://github.com/hyoo-ru/eval.js.hyoo.ru
				<= Lights $mol_lights_toggle
			body /
				<= Menu $mol_list
					rows <= menu /
						<= Menu_link*default $mol_link
							title <= menu_link_title* \
							arg * code <= menu_link_code* \
		<= Code_page $mol_page
			title @ \Code
			bring <= bring
			tools /
				<= Perf $mol_link_iconed
					title \
					hint @ \Measure Performance
					uri <= perf \
				<= Bookmark $mol_check_icon
					Icon <= Bookmark_icon $mol_icon_bookmark_outline
					checked?val <=> bookmark?val false
					hint @ \Bookmark
				<= Run $mol_check_icon
					Icon <= Run_icon $mol_icon_play
					checked?val <=> run?val true
					hint <= result_label
			body /
				<= Code $mol_textarea
					bring => bring
					hint \javascript..
					sidebar_showed true
					spellcheck false
					value?val <=> code?val \
				<= Error_mark $mol_follower
					Anchor <= error_anchor null
					offset <= error_offset /
						0
						0
					Sub <= Error_view $mol_view
						attr * title <= error_message \
						sub / <= Error_icon $mol_icon_flash
		<= Result_page $mol_page
			title <= result_label @ \Result
			tools /
				<= Results_close $mol_link
					arg * run \false
					sub /
						<= Results_close_icon $mol_icon_close
			body /
				<= UI $mol_list sub_visible null
				<= Result $mol_list
					rows <= logs /
						<= Log*0 $mol_dump_list
							values <= log* /
							prototypes true
